<div class="row" *ngIf="widgetType && w && w.timeSeriesList">
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Name</h3>
        <input type="text" placeholder="widget name" max="15" class="form-control" [(ngModel)]="w.name">
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Units</h3>
        <input type="text" placeholder="unit type" max="5" class="form-control" [(ngModel)]="w.units">
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Valid Period</h3>        
        <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
      </div>
    </div>    
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Background Opacity</h3>        
        <select [(ngModel)]="w.opacity" class="form-select">
          <option>30</option>
          <option>40</option>
          <option>50</option>
          <option>60</option>
          <option>70</option>
          <option>80</option>
          <option>90</option>
          <option>100</option>
        </select>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Display Value</h3>        
        <select [(ngModel)]="w.display" class="form-select">
          <option>Latest</option>
          <option>Average</option>
          <option>Maximum</option>
          <option>Minimum</option>
          <option>Change</option>
          <option>Total</option>
        </select>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group">
        <h3>Alternative Value</h3>        
        <select [(ngModel)]="w.alternative" class="form-select">
          <option>Latest</option>
          <option>Average</option>
          <option>Maximum</option>
          <option>Minimum</option>
          <option>Change</option>
        </select>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group input-group-sm">
        <h3>Value Rounding</h3>
        <input
          min="60"
          type="text"
          placeholder="significant figures"
          class="form-control"
          [(ngModel)]="w.significantFigures"
        />
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group input-group-sm">
        <h3>Refresh (Seconds)</h3>
        <input
          min="60"
          type="text"
          placeholder="refresh interval"
          class="form-control"
          [(ngModel)]="w.refreshInterval"
        />
      </div>
    </div>
      
    <div class="col-lg-5" *ngIf="widgetType && w && w.timeSeriesList">
      <div class="form-group input-group-sm">
        <label>Select Time Series </label>
        <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="w.timeSeriesList[0]" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
        <!--<app-time-series-select [timeSeriesDetail]="w.timeSeriesList[0]" [enableTagMatch]="true"></app-time-series-select>-->
      </div>
      <div class="form-group">
        <app-transform-editor [transforms]="w.timeSeriesList[0].transforms"></app-transform-editor>
      </div>
    </div>
    <div class="col-lg-1"></div>
    <div class="col-lg-3">
      <div class="form-group input-group-sm">
        <label>No Data Message</label>
        <input min="60" type="text" placeholder="No Data Message" class="form-control" [(ngModel)]="w.noDataMessage" />
      </div>
    </div>
    <div class="col-lg-3">
      <div class="form-group input-group-sm">
        <input type="checkbox" [(ngModel)]="widget.hideWhenNoData" /> Hide Widget When No Series Found
      </div>
    </div> 
    <div class="col-lg-7">
      <div class="row" *ngIf="widgetType">
        <div class="col-lg-6">
          <div class="panel panel-default">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-opacity-30 bg-default">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.default.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.default.max">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="panel panel-primary">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-opacity-30 bg-primary">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.primary.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.primary.max">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="panel panel-success">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-opacity-30 bg-success">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.success.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.success.max">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>    
        <div class="col-lg-6">
          <div class="panel panel-info">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-opacity-30 bg-info">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.info.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.info.max">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>    
        <div class="col-lg-6">
          <div class="panel panel-warning">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-opacity-30 bg-warning">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.warning.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.warning.max">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="panel panel-danger">
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label">Min / Max</label>
                    <div class="input-group bg-opacity-30 bg-danger">
                      <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.danger.min">
                      <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.danger.max">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>
</div>
